import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HelloComponent } from "./hello.component";
// import { AngularFireModule } from "angularfire2";

/*  */
// 1. Import the libs you need
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireDatabaseModule } from "@angular/fire/database";
import { ColorSketchModule } from 'ngx-color/sketch';
import { WebStorageModule } from "ngx-store";
import { ChatComponent } from "./pages/chat/chat.component";
import { LoginComponent } from "./pages/login/login.component";
import { BackupComponent } from "./pages/backup/backup.component";
import { ImgPreviewComponent } from "./pages/img-preview/img-preview.component";
import { LoaderComponent } from './pages/loader/loader.component';
import { ScrollToBottomDirective } from "./pages/chat/chat.directive";
import { UploadsModule } from "./pages/uploads/uploads.module";
import { ThemeComponent } from './pages/theme/theme.component';
import { GamesComponent } from './pages/games/games.component';
import { SafePipe } from "./pages/games/safe.pipe.directive";
import { HttpClientModule } from '@angular/common/http';
import { PdfViewerModule } from 'ng2-pdf-viewer'; 

export const firebase = {
  apiKey: "AIzaSyAAbOpC7XLZjmu9MJ0HtiiuQXxAhM0GOYE",
  authDomain: "chat-peace-s.firebaseapp.com",
  databaseURL: "https://chat-peace-s.firebaseio.com",
  projectId: "chat-peace-s",
  storageBucket: "chat-peace-s.appspot.com",
  messagingSenderId: "833228858212",
  appId: "1:833228858212:web:bb49a1bc88239926"
};

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    AngularFireModule.initializeApp(firebase),
    WebStorageModule,
    AppRoutingModule,
    AngularFireDatabaseModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireAuthModule,
    UploadsModule,
    ColorSketchModule,
    HttpClientModule,
    PdfViewerModule
  ],
  declarations: [
    AppComponent,
    HelloComponent,
    ChatComponent,
    LoginComponent,
    BackupComponent,
    ImgPreviewComponent,
    LoaderComponent,
    ScrollToBottomDirective,
    ThemeComponent,
    GamesComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
